// extracted by css-extract-rspack-plugin
export default {"chart_container_2bars":"WUp6rAR7qrYZtOeJ","chart_container_3bars":"KXDcXkk4s7wpOauk","chart_container_more3bars":"Ypz8ikb36PMHVMJc","chart_container_radar":"VDVbO5usgko5z_I4"};